import styled, { css } from 'styled-components';
import { ContentInterface } from './ModalUpdatedAddressTypes';

export const visibilityAnimationRight = css`
  &.animated {
    right: 0;
    opacity: 1;
    transition: right 0.3s cubic-bezier(0.65, 0, 0.35, 1),
      opacity 0.3s cubic-bezier(0.65, 0, 0.35, 1);
  }
`;

export const maxWidthModalUpdatedAddress = '546px';

export const Content = styled.div<ContentInterface>`
  width: 100%;
  max-width: ${maxWidthModalUpdatedAddress};
  background-color: #fff;
  position: fixed;
  top: 0;
  right: -100%;
  height: 100%;
  overflow-y: auto;
  opacity: 1;
  transition: right 0.3s cubic-bezier(0.65, 0, 0.35, 1),
    opacity 0.3s cubic-bezier(0.65, 0, 0.35, 1);

  ${({ theme }) => css`
    padding: ${theme.spacing.km6} ${theme.spacing.km8} 120px
      ${theme.spacing.km8};
  `}

  ${visibilityAnimationRight}
`;

export const WrapperActions = styled.div`
  position: relative;
`;
